module.exports = __webpack_public_path__ + "img/Size=16, Style=solid.84497dce.svg";